module.exports = __webpack_public_path__ + "img/avatar7.508f06dd.png";